import StopSharingButton from "./StopSharingButton";

export default StopSharingButton;
